import { getAnchorScrollTop } from '../common/_common';

/**
 * あらすじ一覧（スライダー / アンカー / スクロール連動）
 */
export function storyFunc() {
  const root = document.querySelector('[data-story-archive]');
  if (!root) return;

  const list = root.querySelector('[data-story-list]');
  const anchors = Array.prototype.slice.call(root.querySelectorAll('[data-story-anchor]'));

  if (!list) return;

  initSliders(list);
  bindAnchors();
  bindScrollSpy();

  // ハッシュ直リンク対応
  const hash = window.location.hash.replace(/^#/, '');
  if (hash.indexOf('story-') === 0) {
    const targetNum = parseInt(hash.replace('story-', ''), 10);
    if (targetNum > 0) {
      window.setTimeout(() => {
        goToStory(targetNum);
      }, 100);
    }
  }

  function setActiveAnchor(number) {
    anchors.forEach((anchor) => {
      const n = parseInt(anchor.getAttribute('data-story-target') || '0', 10);
      anchor.classList.toggle('is-active', n === number);
    });
  }

  function getCardByNumber(number) {
    return list.querySelector('[data-story-number="' + number + '"]');
  }

  function scrollToCard(card, number) {
    if (!card) return;
    const id = card.id || '';
    window.scrollTo({
      top: getAnchorScrollTop(card, id),
      behavior: 'smooth',
    });
    if (id && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + id);
    }
    setActiveAnchor(number);
  }

  function goToStory(number) {
    const card = getCardByNumber(number);
    if (card) {
      scrollToCard(card, number);
    }
  }

  function bindAnchors() {
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const number = parseInt(anchor.getAttribute('data-story-target') || '0', 10);
        if (!number) return;
        goToStory(number);
      });
    });
  }

  function bindScrollSpy() {
    if (!('IntersectionObserver' in window)) return;
    const spy = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const number = parseInt(entry.target.getAttribute('data-story-number') || '0', 10);
          if (number) setActiveAnchor(number);
        });
      },
      { rootMargin: '-30% 0px -60% 0px', threshold: 0 }
    );

    list.querySelectorAll('[data-story-card]').forEach((card) => spy.observe(card));
  }
}

/**
 * スライダー初期化（対象配下）
 *
 * @param {ParentNode} scope
 */
function initSliders(scope) {
  const sliders = scope.querySelectorAll
    ? scope.querySelectorAll('[data-story-slider]')
    : [];

  Array.prototype.forEach.call(sliders, (slider) => {
    if (slider.getAttribute('data-story-slider-ready') === '1') return;
    const track = slider.querySelector('[data-story-slider-track]');
    const slides = track ? track.querySelectorAll('.p-story__slider-slide') : [];
    if (!track || slides.length <= 1) {
      slider.setAttribute('data-story-slider-ready', '1');
      return;
    }

    let index = 0;
    const dots = slider.querySelectorAll('[data-story-slider-dot]');
    const prev = slider.querySelector('[data-story-slider-prev]');
    const next = slider.querySelector('[data-story-slider-next]');

    const update = () => {
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    };

    if (prev) {
      prev.addEventListener('click', () => {
        index = (index - 1 + slides.length) % slides.length;
        update();
      });
    }
    if (next) {
      next.addEventListener('click', () => {
        index = (index + 1) % slides.length;
        update();
      });
    }
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        index = parseInt(dot.getAttribute('data-story-slider-dot') || '0', 10) || 0;
        update();
      });
    });

    update();
    slider.setAttribute('data-story-slider-ready', '1');
  });
}
